<div [class]="'progress-bar-container ' + status">
  <sm-experiment-info-header-status-icon-label
    [status]="status"
    class="w-100">
  </sm-experiment-info-header-status-icon-label>
</div>
